import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import { IIsaacLink } from 'shared/interfaces'

const ProjectMetricsIsaak: FC<{ isaacLinks: IIsaacLink[]; title: string }> = ({ isaacLinks, title }) =>
  isaacLinks && !!isaacLinks.length ? (
    <div className="project-metrics__isaac-links">
      <h4 className="project-metrics__title">{title}</h4>
      {isaacLinks.map((link: IIsaacLink) => (
        <a href={link.url} key={link.url} className="lgt-button lgt-button--sm lgt-button--secondary-black lgt-button--outline">
          {link.title}
          <Icon name="external-link" />
        </a>
      ))}{' '}
    </div>
  ) : null

export default ProjectMetricsIsaak
